import React from "react"

import { GridDiagramCellSize } from "./GridDiagramCell"
import { Size } from "../helpers/parseSize"
import { TestProps } from "../helpers/TestProps"
import { GridDiagramCellInfo } from "./GridDiagramCellInfo"
import { BaseGridDiagram, BaseGridDiagramCell} from "./BaseGridDiagram"
import { renderTestID } from "../helpers/renderTestID"
import { GridDiagramRow } from "./GridDiagramRow"

export interface GridDiagramProps extends TestProps {

  /**
   * Spacing between the cells in the grid.
   */
  spacingSize?: Size

  /**
   * Size used to render the inner CartSlot components.
   */
  cellSize?: GridDiagramCellSize

  grid: GridDiagramRow[]
}

/**
 * Renders a grid of cells.
 */
export class GridDiagram extends React.PureComponent<GridDiagramProps> {

  private buildCell = (cell: GridDiagramCellInfo): BaseGridDiagramCell => {
    return ({
      ...cell,
      size: this.props.cellSize
    })
  }

  public render() {
    return (
      <div className="grid-diagram" data-testid={renderTestID(this.props.testID)}>
        <BaseGridDiagram
          {...this.props}
          buildCell={this.buildCell}
        />
      </div>
    )
  }
}
